/* Spanish catalog mirroring locale-firm-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'rf.loading.firm': 'Cargando tu despacho …',
  'rf.loading.clients': 'Obteniendo tus clientes …',
  'rf.loading.reconciliation': 'Obteniendo las conciliaciones …',
  'rf.loading.control': 'Obteniendo las tareas de control …',
  'rf.loading.ledger': 'Cargando la contabilidad del cliente …',
  'rf.pageError.title': 'No se pudo cargar la página',
  'rf.pageError.text': 'Vuelve a cargar la superficie del despacho. Si el problema persiste, el script de esta página no está disponible.',
  'rf.client.assignCount': 'Asignar ({count})',
  'rf.client.assignAll': 'Todo el despacho',
  'rf.client.assignNobody': 'El despacho aún no tiene compañeros activos para asignar al encargo.',
  'rf.client.assignRoleHint': 'El rol se aplica a todos los que marques. Quien ya esté en el encargo recibe el nuevo rol.',
  'rf.client.assignedMany': '{count} compañeros se han asignado al encargo',
  'rf.nav.myPage': 'Mi página',
  'rf.nav.firmBooks': 'A la contabilidad del despacho',
});
